document.addEventListener('DOMContentLoaded', () => {
  const originalFetch = window.fetch;
  window.fetch = async function (url, options = {}) {
    if (typeof url === 'string' && url.includes('/cart/add')) {
      try {
        const body = JSON.parse(options.body);
        const card = document.querySelector(`[data-product-id="${body.id}"]`);
        if (card) {
          body.properties = {
            ...body.properties,
            ...(card.dataset.productLocation && {
              _Location: card.dataset.productLocation,
            }),
            ...(card.dataset.caseLocation && {
              _Case_Location: card.dataset.caseLocation,
            }),
          };
          options.body = JSON.stringify(body);
        }
      } catch (e) {}
    }
    return originalFetch.apply(this, [url, options]);
  };
});